<div class="asideMenu d-flex flex-column align-items-center">
  <p-panelMenu [model]="items"></p-panelMenu>
  <p class="text-center p-2 mt-auto font-weight-light w-100 align-self-end">
    &copy; Robovisor. All rights reserved.<br />{{ version }}
  </p>
</div>
